import { render, staticRenderFns } from "./noticeItem.vue?vue&type=template&id=1e54c6ac&scoped=true"
import script from "./noticeItem.vue?vue&type=script&lang=js"
export * from "./noticeItem.vue?vue&type=script&lang=js"
import style0 from "./noticeItem.vue?vue&type=style&index=0&id=1e54c6ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e54c6ac",
  null
  
)

export default component.exports